export default __webpack_public_path__ + "static/media/packair-industries.aa4aa081.webp";